import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import StorageService from "../../services/StorageService";
import StockInfoService from "../../services/stockInfoService";
import InventoryReportService from "../../services/inventoryReportService";
import ReactPaginate from "react-paginate";
import utility from "./../../utils/utility";
import ItemService from "../../services/ItemsServices";
import CompanyService from "../../services/companyService";
import ProjectService from "../../services/ProjectService";
import ProjectStoreService from "../../services/ProjectStoreService";
import ProjectItemService from "../../services/ProjectItemService";
import XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from '../../assets/images/deviops_logo.png';
import { addPdfLogo, getPdfLogoDataUrl } from "../../utils/pdfLogo";



export default function InventoryTransactionReport() {

  const [fromProject, setFromProject] = useState("");
  const [toProject, setToProject] = useState("");

  const [fromStore, setFromStore] = useState("");
  const [toStore, setToStore] = useState("");

  const comp = StorageService.activeCompany();
  const employeeId = StorageService.loginData().employeeId;
  const roleId = StorageService.loginData().roleId;

  const [fromCompany, setFromCompany] = useState(comp.companyId);
  const [toCompany, setToCompany] = useState("");

  const [itemCategory, setItemCategory] = useState("");
  const [itemName, setItemName] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // DROPDOWNS
  const [projects, setProjects] = useState([]);
  const [stores, setStores] = useState([]);
  const [items, setItems] = useState([]);

  // SELECTED VALUES
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [selectedItemId, setSelectedItemId] = useState("");

  const [companies, setCompanies] = useState([]);
  const [toProjects, setToProjects] = useState([]);
  const [toStores, setToStores] = useState([]);

  const [categories, setCategories] = useState([]);
  const [projectFullData, setProjectFullData] = useState([]);
  // TABLE
  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");


  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);

    setTimeout(() => {
      setMessage("");
    }, 3000);
  };

  const handleClearFilters = () => {
    // reset all filters
    setFromCompany(comp.companyId);
    setToCompany("");

    setFromProject("");
    setToProject("");

    setFromStore("");
    setToStore("");

    setItemCategory("");
    setItemName("");

    setFromDate("");
    setToDate("");

    // reset dependent data
    setStores([]);
    setToStores([]);
    setCategories([]);
    setItems([]);

    // reset pagination
    setCurrentPage(1);
  };


  /* ================= LOAD PROJECTS (FIRST) ================= */
  useEffect(() => {
    loadCompanies();
  }, []);

  useEffect(() => {
    if (fromCompany) {
      loadProjects(fromCompany);   //  always based on selected company
      loadReport();
    }
  }, [fromCompany]);



  useEffect(() => {
    if (
      !toCompany &&
      !fromProject &&
      !toProject &&
      !fromStore &&
      !toStore &&
      !itemCategory &&
      !itemName &&
      !fromDate &&
      !toDate
    ) {
      loadReport();
    }
  }, [
    toCompany,
    fromProject,
    toProject,
    fromStore,
    toStore,
    itemCategory,
    itemName,
    fromDate,
    toDate
  ]);

  /* ================= PROJECT → STORES ================= */
  // useEffect(() => {
  //   if (!selectedProjectId) return;
  //   setSelectedStoreId("");
  //   setSelectedItemId("");
  //   setStores([]);
  //   setItems([]);
  //   setTableData([]);
  //   loadStores();
  // }, [selectedProjectId]);

  /* ================= STORE → ITEMS ================= */
  // useEffect(() => {
  //   if (!selectedStoreId) return;
  //   setSelectedItemId("");
  //   setItems([]);
  //   setTableData([]);
  //   loadItems();
  // }, [selectedStoreId]);


  const loadCompanies = async () => {
    try {
      const res = await CompanyService.getActiveCompanies();
      setCompanies(res?.data || res || []);
    } catch {
      setCompanies([]);
    }
  };

  // const loadProjects = async () => {
  //   const comp = StorageService.activeCompany();
  //   const emp = StorageService.loginData();

  //   const res = await InventoryReportService.getProjectsForInventoryReport({
  //     companyId: comp.companyId,
  //     employeeId: emp.employeeId,
  //     roleId: emp.roleId
  //   });

  //   const data = res.result || [];

  //   const mapped = data.map(p => ({
  //     id: p.id || p.projectId,
  //     projectName: p.projectName,
  //     projectCode: p.projectCode
  //   }));

  //   setProjects(mapped);

  // };
  // useEffect(() => {
  //   if (Number(roleId) !== 1) {
  //     setFromCompany(comp.companyId);
  //   }
  // }, []);

  const loadProjects = async (companyId) => {
    const emp = StorageService.loginData();

    const res = await InventoryReportService.getProjectsForInventoryReport({
      companyId,
      employeeId: emp.employeeId,
      roleId: emp.roleId
    });

    const data = res.result || [];

    const mapped = data.map(p => ({
      id: p.id || p.projectId,
      projectName: p.projectName,
      projectCode: p.projectCode,
      categoryName: p.projectCategory || p.projectCategoryName || p.categoryName || p.category || ""
    }));

    setProjects(mapped);
  };

  const loadToProjects = async (companyId) => {
    try {
      const res = await ProjectService.getActive(companyId);

      const mapped = (res || []).map(p => ({
        id: p.id,
        projectName: p.projectName,
        projectCode: p.projectCode,
        categoryName: p.projectCategory || p.projectCategoryName || p.categoryName || p.category || ""
      }));

      setToProjects(mapped);
    } catch {
      setToProjects([]);
    }
  };

  const loadStores = async (projectId, type = "FROM") => {
    const res = await ProjectStoreService.getProjectStoreById(projectId);

    if (type === "FROM") setStores(res.data || res || []);
    else setToStores(res.data || res || []);
  };

  const loadItems = async (categoryId) => {
    if (!categoryId) {
      setItems([]);
      return;
    }
    const res = await ItemService.getItemByCategoryId(categoryId);
    setItems(res.data || []);
  };

  const loadProjectFullData = async (projectId) => {
    const res = await ProjectItemService.getProjectFullData(projectId);
    const data = res?.data?.data || [];

    setProjectFullData(data);
    setCategories(data);
  };

  /* ================= VIEW REPORT ================= */
  const loadReport = async (pageNumber = currentPage) => {
    if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
      showMessage("From Date should be less than To Date", "error");
      return;
    }

    const comp = StorageService.activeCompany();
    const emp = StorageService.loginData();

    try {
      setTableLoading(true);
      setCurrentPage(1);
      const res = await InventoryReportService.getInventoryTransactionReport({
        pageNumber: pageNumber,
        noofRows: itemsPerPage,
        companyId: comp.companyId,
        employeeId: emp.employeeId,
        roleId: emp.roleId,

        fromCompany: fromCompany,
        toCompany: toCompany || undefined,

        fromProject: fromProject || undefined,
        toProject: toProject || undefined,

        fromStore: fromStore || undefined,
        toStore: toStore || undefined,

        itemCategory: itemCategory || undefined,
        itemName: itemName || undefined,

        fromDate: fromDate || undefined,
        toDate: toDate || undefined
      });

      setTableData(res.data || []);
      setPageCount(res.pageNation?.totalPages || 0);
    } catch (err) {
      setTableData([]);
    } finally {
      setTableLoading(false);
    }
  };

  const handleSearchClick = () => {
    setCurrentPage(1);
    loadReport(1);
  };

  const getAllReportData = async () => {
    const comp = StorageService.activeCompany();
    const emp = StorageService.loginData();
    let allData = [];
    let pageNumber = 1;
    let totalPages = 1;

    try {
      do {
        const res = await InventoryReportService.getInventoryTransactionReport({
          pageNumber: pageNumber,
          noofRows: 50,
          companyId: comp.companyId,
          employeeId: emp.employeeId,
          roleId: emp.roleId,

          fromCompany: fromCompany,
          toCompany: toCompany || undefined,

          fromProject: fromProject || undefined,
          toProject: toProject || undefined,

          fromStore: fromStore || undefined,
          toStore: toStore || undefined,

          itemCategory: itemCategory || undefined,
          itemName: itemName || undefined,

          fromDate: fromDate || undefined,
          toDate: toDate || undefined
        });

        allData = [...allData, ...(res.data || [])];
        totalPages = res.pageNation?.totalPages || 1;
        pageNumber++;
      } while (pageNumber <= totalPages);

      return allData;
    } catch (err) {
      console.error("Export data error:", err);
      return [];
    }
  };

  const exportExcel = async () => {
    setTableLoading(true);
    const allData = await getAllReportData();
    setTableLoading(false);

    if (!allData.length) {
      showMessage("No data to export", "error");
      return;
    }

    const toNumber = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const wb = XLSX.utils.book_new();
    const ws = {};
    ws["!merges"] = [];

    // Filter Labels
    let fromCompanyLabel = "All";
    if (fromCompany) {
      const found = companies.find(c => String(c.id) === String(fromCompany));
      fromCompanyLabel = found?.companyName || fromCompany;
    } else {
      fromCompanyLabel = comp.companyName || "All";
    }

    let toCompanyLabel = "All";
    if (toCompany) {
      const found = companies.find(c => String(c.id) === String(toCompany));
      toCompanyLabel = found?.companyName || toCompany;
    }

    let fromProjectLabel = "All";
    if (fromProject) {
      const found = projects.find(p => String(p.id) === String(fromProject));
      const init = found ? String(found.categoryName || "").trim().charAt(0).toUpperCase() : "";
      const pFormatted = found ? (init ? `${init}*${found.projectName}` : found.projectName) : fromProject;
      fromProjectLabel = found ? pFormatted : fromProject;
    }

    let toProjectLabel = "All";
    if (toProject) {
      const found = toProjects.find(p => String(p.id || p.projectId) === String(toProject)) || projects.find(p => String(p.id || p.projectId) === String(toProject));
      const init = found ? String(found.categoryName || "").trim().charAt(0).toUpperCase() : "";
      const pFormatted = found ? (init ? `${init}*${found.projectName}` : found.projectName) : toProject;
      toProjectLabel = found ? pFormatted : toProject;
    }

    let fromStoreLabel = "All";
    if (fromStore) {
      const found = stores.find(s => String(s.storeId || s.id) === String(fromStore));
      fromStoreLabel = found?.storeName || fromStore;
    }

    let toStoreLabel = "All";
    if (toStore) {
      const found = toStores.find(s => String(s.storeId || s.id) === String(toStore));
      toStoreLabel = found?.storeName || toStore;
    }

    let categoryLabel = "All";
    if (itemCategory) {
      const found = categories.find(c => String(c.itemCategoryId) === String(itemCategory));
      categoryLabel = found?.itemCategoryName || itemCategory;
    }

    let itemLabel = "All";
    if (itemName) {
      itemLabel = itemName;
    }

    let row = 0;
    const companyHeaderName = comp.companyName || "Company";

    // STYLES
    const thinBorder = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    };
    const centerAlign = {
      horizontal: "center",
      vertical: "center",
      wrapText: true
    };
    const leftAlign = {
      horizontal: "left",
      vertical: "center",
      wrapText: true
    };

    // COMPANY NAME (Top Left) & REPORT DATE (Top Right)
    const headerReportDateStr = `Report Date: ${utility.formatExportDateTime(new Date())}`;
    XLSX.utils.sheet_add_aoa(
      ws,
      [[companyHeaderName, "", "", "", "", "", "", "", "", "", "", "", "", "", "", headerReportDateStr, "", "", "", "", "", "", "", ""]],
      { origin: { r: row, c: 0 } }
    );
    ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: 14 } });
    ws["!merges"].push({ s: { r: row, c: 15 }, e: { r: row, c: 23 } });
    ws[XLSX.utils.encode_cell({ r: row, c: 0 })].s = {
      font: { bold: true, sz: 12 },
      alignment: { horizontal: "left", vertical: "center" }
    };
    ws[XLSX.utils.encode_cell({ r: row, c: 15 })].s = {
      font: { bold: true, sz: 10 },
      alignment: { horizontal: "right", vertical: "center" }
    };

    row++;

    // TITLE
    XLSX.utils.sheet_add_aoa(ws, [["Inventory Transaction Report"]], { origin: { r: row, c: 0 } });
    ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: 23 } });
    const titleCell = XLSX.utils.encode_cell({ r: row, c: 0 });
    ws[titleCell].s = {
      font: { bold: true, sz: 16 },
      alignment: { horizontal: "center", vertical: "center" }
    };

    row += 2;

    // FILTERS INFO (Left column and Right column layout)
    XLSX.utils.sheet_add_aoa(ws, [
      ["From Company:", fromCompanyLabel, "", "To Company:", toCompanyLabel, "", "From Project:", fromProjectLabel, "", "To Project:", toProjectLabel],
      ["From Store:", fromStoreLabel, "", "To Store:", toStoreLabel, "", "Item Category:", categoryLabel, "", "Item:", itemLabel],
      ["Start Date:", fromDate ? utility.formatDateDDMMMYYYY(fromDate) : "-", "", "End Date:", toDate ? utility.formatDateDDMMMYYYY(toDate) : "-"]
    ], { origin: { r: row, c: 0 } });

    const filterLabelStyle = {
      font: { bold: true, sz: 10 },
      alignment: { horizontal: "left", vertical: "center" },
      border: thinBorder
    };

    const filterValueStyle = {
      font: { sz: 10 },
      alignment: { horizontal: "left", vertical: "center" },
      border: thinBorder
    };

    const labelColumns = [0, 3, 6, 9];
    for (let i = 0; i < 3; i++) {
      for (let c = 0; c < 11; c++) {
        const cell = XLSX.utils.encode_cell({ r: row + i, c });
        if (!ws[cell]) continue;
        if (labelColumns.includes(c)) {
          ws[cell].s = filterLabelStyle;
        } else {
          ws[cell].s = filterValueStyle;
        }
      }
    }

    row += 4;

    // TABLE HEADER
    const headers = [
      "Sr.No",
      "Transaction Type",
      "Transaction Date",
      "From Company",
      "From Project Code",
      "From Project",
      "To Location",
      "From Store",
      "To Company",
      "To Project Code",
      "To Project",
      "To Store",
      "Invoice No",
      "Vehicle No",
      "Category",
      "Item Name",
      "UOM",
      "Issue Qty",
      "Quantity",
      "Damaged Qty",
      "Lost Qty",
      "Remarks",
      "Issues By",
      "Received By"
    ];

    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: { r: row, c: 0 } });

    headers.forEach((_, colIndex) => {
      const cell = XLSX.utils.encode_cell({ r: row, c: colIndex });
      ws[cell].s = {
        font: { bold: true, sz: 10 },
        alignment: centerAlign,
        border: thinBorder
      };
    });

    row++;

    const rightAlign = {
      horizontal: "right",
      vertical: "center",
      wrapText: true
    };

    // TABLE DATA
    allData.forEach((reportRow, index) => {
      const dateSerial = utility.convertDateToExcelSerial(reportRow.transactionDate) || "-";
      const issueQty = reportRow.transactionType !== "Inword" ? toNumber(reportRow.issuedQuantity) : "-";
      const qty = reportRow.transactionType !== "Outword" ? toNumber(reportRow.quantity) : "-";
      const damagedQty = reportRow.transactionType === "Transfer" ? (reportRow.damagedQuantity !== null && reportRow.damagedQuantity !== undefined ? toNumber(reportRow.damagedQuantity) : 0) : "-";
      const lostQty = reportRow.transactionType === "Transfer" ? (reportRow.lostQuantity !== null && reportRow.lostQuantity !== undefined ? toNumber(reportRow.lostQuantity) : 0) : "-";

      const rowData = [
        index + 1,
        reportRow.transactionType || "-",
        dateSerial,
        reportRow.fromCompany || "-",
        reportRow.fromProjectCode || "-",
        reportRow.fromProject || "-",
        reportRow.toLocation || "-",
        reportRow.fromStore || "-",
        reportRow.toCompany || "-",
        reportRow.toProjectCode || "-",
        reportRow.toProject || "-",
        reportRow.toStore || "-",
        reportRow.invoiceNo || "-",
        reportRow.vehicleNo || "-",
        reportRow.category || "-",
        reportRow.itemCode || "-",
        reportRow.uomCode || "-",
        issueQty,
        qty,
        damagedQty,
        lostQty,
        reportRow.remarks || "-",
        reportRow.issuesBy || "-",
        reportRow.receivedBy || "-"
      ];

      XLSX.utils.sheet_add_aoa(ws, [rowData], { origin: { r: row, c: 0 } });

      rowData.forEach((_, colIndex) => {
        const cell = XLSX.utils.encode_cell({ r: row, c: colIndex });
        const isNumQty = [17, 18, 19, 20].includes(colIndex);
        const isRight = colIndex === 0 || (isNumQty && typeof rowData[colIndex] === 'number');
        const isDate = colIndex === 2;

        ws[cell].s = {
          alignment: isRight ? rightAlign : (isDate ? centerAlign : leftAlign),
          border: thinBorder,
          font: { sz: 9 }
        };

        // Sr.No
        if (colIndex === 0) {
          ws[cell].t = 'n';
          ws[cell].z = '0';
        }

        // Transaction Date
        if (colIndex === 2 && typeof ws[cell].v === 'number') {
          ws[cell].t = 'n';
          ws[cell].z = 'dd-mm-yyyy';
        }

        // Quantities
        if (isNumQty && typeof rowData[colIndex] === 'number') {
          ws[cell].t = 'n';
          ws[cell].z = '#,##0.000';
        }
      });

      row++;
    });

    // FOOTER FOR TOTAL QUANTITY
    const totalIssued = allData.reduce((sum, r) => sum + (r.transactionType !== "Inword" ? toNumber(r.issuedQuantity) : 0), 0);
    const totalQuantity = allData.reduce((sum, r) => sum + (r.transactionType !== "Outword" ? toNumber(r.quantity) : 0), 0);
    const totalDamaged = allData.reduce((sum, r) => sum + (r.transactionType === "Transfer" ? toNumber(r.damagedQuantity) : 0), 0);
    const totalLost = allData.reduce((sum, r) => sum + (r.transactionType === "Transfer" ? toNumber(r.lostQuantity) : 0), 0);
    const footerRow = Array(24).fill("");
    footerRow[16] = "Total:";
    footerRow[17] = totalIssued;
    footerRow[18] = totalQuantity;
    footerRow[19] = totalDamaged;
    footerRow[20] = totalLost;

    XLSX.utils.sheet_add_aoa(ws, [footerRow], { origin: { r: row, c: 0 } });

    for (let c = 0; c < 24; c++) {
      const cell = XLSX.utils.encode_cell({ r: row, c });
      const isNum = [17, 18, 19, 20].includes(c);
      ws[cell].s = {
        font: { bold: true, sz: 10 },
        alignment: isNum || c === 16 ? rightAlign : centerAlign,
        border: thinBorder
      };
      if (isNum) {
        ws[cell].t = 'n';
        ws[cell].z = '#,##0.000';
      }
    }

    // Set column widths
    ws["!cols"] = [
      { wch: 6 },  // Sr.No
      { wch: 15 }, // Transaction Type
      { wch: 20 }, // Transaction Date
      { wch: 22 }, // From Company
      { wch: 18 }, // From Project Code
      { wch: 22 }, // From Project
      { wch: 20 }, // To Location
      { wch: 20 }, // From Store
      { wch: 22 }, // To Company
      { wch: 18 }, // To Project Code
      { wch: 22 }, // To Project
      { wch: 20 }, // To Store
      { wch: 15 }, // Invoice No
      { wch: 15 }, // Vehicle No
      { wch: 20 }, // Category
      { wch: 20 }, // Item Name
      { wch: 10 }, // UOM
      { wch: 12 }, // Issue Qty
      { wch: 12 }, // Quantity
      { wch: 12 }, // Damaged Qty
      { wch: 12 }, // Lost Qty
      { wch: 20 }, // Remarks
      { wch: 15 }, // Issues By
      { wch: 15 }  // Received By
    ];

    XLSX.utils.book_append_sheet(wb, ws, "InventoryTransactions");
    XLSX.writeFile(wb, `InventoryTransactionReport_${utility.formatDateDMY(new Date()).replace(/\//g, "-")}.xlsx`);
  };

  const exportPdf = async () => {
    setTableLoading(true);
    const allData = await getAllReportData();
    setTableLoading(false);

    if (!allData.length) {
      showMessage("No data to export", "error");
      return;
    }

    // Filter Labels
    let fromCompanyLabel = "All";
    if (fromCompany) {
      const found = companies.find(c => String(c.id) === String(fromCompany));
      fromCompanyLabel = found?.companyName || fromCompany;
    } else {
      fromCompanyLabel = comp.companyName || "All";
    }

    let toCompanyLabel = "All";
    if (toCompany) {
      const found = companies.find(c => String(c.id) === String(toCompany));
      toCompanyLabel = found?.companyName || toCompany;
    }

    let fromProjectLabel = "All";
    if (fromProject) {
      const found = projects.find(p => String(p.id) === String(fromProject));
      const init = found ? String(found.categoryName || "").trim().charAt(0).toUpperCase() : "";
      const pFormatted = found ? (init ? `${init}*${found.projectName}` : found.projectName) : fromProject;
      fromProjectLabel = found ? pFormatted : fromProject;
    }

    let toProjectLabel = "All";
    if (toProject) {
      const found = toProjects.find(p => String(p.id || p.projectId) === String(toProject)) || projects.find(p => String(p.id || p.projectId) === String(toProject));
      const init = found ? String(found.categoryName || "").trim().charAt(0).toUpperCase() : "";
      const pFormatted = found ? (init ? `${init}*${found.projectName}` : found.projectName) : toProject;
      toProjectLabel = found ? pFormatted : toProject;
    }

    let fromStoreLabel = "All";
    if (fromStore) {
      const found = stores.find(s => String(s.storeId || s.id) === String(fromStore));
      fromStoreLabel = found?.storeName || fromStore;
    }

    let toStoreLabel = "All";
    if (toStore) {
      const found = toStores.find(s => String(s.storeId || s.id) === String(toStore));
      toStoreLabel = found?.storeName || toStore;
    }

    let categoryLabel = "All";
    if (itemCategory) {
      const found = categories.find(c => String(c.itemCategoryId) === String(itemCategory));
      categoryLabel = found?.itemCategoryName || itemCategory;
    }

    let itemLabel = "All";
    if (itemName) {
      itemLabel = itemName;
    }

    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const companyHeaderName = comp.companyName || "Company";

    // Pre-convert logo to Data URL for 100% reliable rendering in production build
    let pdfLogo = null;
    try {
      pdfLogo = await getPdfLogoDataUrl(logo);
    } catch (e) {
      console.error("PDF logo load error:", e);
    }

    const drawHeader = (yPos) => {
      doc.setFontSize(12);
      doc.setFont(undefined, "bold");
      const companyNameWidth = doc.getTextWidth(companyHeaderName);
      const logoWidth = 5;
      const logoHeight = 10;
      const logoX = 14 + 6 + (companyNameWidth - logoWidth) / 2;
      const logoY = yPos;

      if (pdfLogo) {
        doc.addImage(pdfLogo, "PNG", logoX, logoY, logoWidth, logoHeight);
      }
      doc.text(companyHeaderName, 14 + 6, yPos + 15);

      const reportPrefix = "Report Date: ";
      const reportDateStr = utility.formatExportDateTime(new Date());

      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      const prefixWidth = doc.getTextWidth(reportPrefix);

      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
      const dateWidth = doc.getTextWidth(reportDateStr);

      const totalWidth = prefixWidth + dateWidth;
      const right = pageWidth - 14;
      const startX = right - totalWidth;

      doc.setFont(undefined, "bold");
      doc.text(reportPrefix, startX, yPos + 15);

      doc.setFont(undefined, "normal");
      doc.text(reportDateStr, startX + prefixWidth, yPos + 15);

      const title = "Inventory Transaction Report";
      doc.setFontSize(16);
      doc.setFont(undefined, "bold");
      const titleWidth = doc.getTextWidth(title);
      const centerX = pageWidth / 2;
      doc.text(title, centerX, yPos + 27, { align: "center" });

      doc.setLineWidth(0.3);
      doc.line(centerX - titleWidth / 2, yPos + 29, centerX + titleWidth / 2, yPos + 29);
    };

    let yPosition = 8;
    drawHeader(yPosition);
    yPosition += 35;

    doc.setFontSize(8);
    doc.setFont(undefined, "bold");

    let xLeft1 = 14;
    let xLeft2 = 85;
    let xLeft3 = 155;
    let xLeft4 = 225;

    doc.text("From Company:", xLeft1, yPosition);
    doc.setFont(undefined, "normal");
    doc.text(String(fromCompanyLabel), xLeft1 + 25, yPosition);

    doc.setFont(undefined, "bold");
    doc.text("To Company:", xLeft2, yPosition);
    doc.setFont(undefined, "normal");
    doc.text(String(toCompanyLabel), xLeft2 + 22, yPosition);

    doc.setFont(undefined, "bold");
    doc.text("From Project:", xLeft3, yPosition);
    doc.setFont(undefined, "normal");
    doc.text(String(fromProjectLabel), xLeft3 + 22, yPosition);

    doc.setFont(undefined, "bold");
    doc.text("To Project:", xLeft4, yPosition);
    doc.setFont(undefined, "normal");
    doc.text(String(toProjectLabel), xLeft4 + 20, yPosition);

    yPosition += 5;

    doc.setFont(undefined, "bold");
    doc.text("From Store:", xLeft1, yPosition);
    doc.setFont(undefined, "normal");
    doc.text(String(fromStoreLabel), xLeft1 + 25, yPosition);

    doc.setFont(undefined, "bold");
    doc.text("To Store:", xLeft2, yPosition);
    doc.setFont(undefined, "normal");
    doc.text(String(toStoreLabel), xLeft2 + 22, yPosition);

    doc.setFont(undefined, "bold");
    doc.text("Item Category:", xLeft3, yPosition);
    doc.setFont(undefined, "normal");
    doc.text(String(categoryLabel), xLeft3 + 22, yPosition);

    doc.setFont(undefined, "bold");
    doc.text("Item:", xLeft4, yPosition);
    doc.setFont(undefined, "normal");
    doc.text(String(itemLabel), xLeft4 + 20, yPosition);

    yPosition += 5;

    doc.setFont(undefined, "bold");
    doc.text("Start Date:", xLeft1, yPosition);
    doc.setFont(undefined, "normal");
    doc.text(fromDate ? utility.formatDateDDMMMYYYY(fromDate) : "-", xLeft1 + 25, yPosition);

    doc.setFont(undefined, "bold");
    doc.text("End Date:", xLeft2, yPosition);
    doc.setFont(undefined, "normal");
    doc.text(toDate ? utility.formatDateDDMMMYYYY(toDate) : "-", xLeft2 + 22, yPosition);

    yPosition += 10;

    const headers = [[
      "#",
      "Type",
      "Date",
      "From Co",
      "From Proj Code",
      "From Proj",
      "To Location",
      "From Store",
      "To Co",
      "To Proj Code",
      "To Proj",
      "To Store",
      "Inv No",
      "Veh No",
      "Category",
      "Item Name",
      "UOM",
      "Issue Qty",
      "Qty",
      "Damaged Qty",
      "Lost Qty",
      "Remarks",
      "Issues By",
      "Recd By"
    ]];

    const body = allData.map((row, index) => [
      index + 1,
      row.transactionType || "-",
      row.transactionDate ? utility.formatDateTime(row.transactionDate) : "-",
      row.fromCompany || "-",
      row.fromProjectCode || "-",
      row.fromProject || "-",
      row.toLocation || "-",
      row.fromStore || "-",
      row.toCompany || "-",
      row.toProjectCode || "-",
      row.toProject || "-",
      row.toStore || "-",
      row.invoiceNo || "-",
      row.vehicleNo || "-",
      row.category || "-",
      row.itemCode || "-",
      row.uomCode || "-",
      row.transactionType !== "Inword" ? parseFloat(row.issuedQuantity || 0).toFixed(3) : "-",
      row.transactionType !== "Outword" ? parseFloat(row.quantity || 0).toFixed(3) : "-",
      row.transactionType === "Transfer" ? (row.damagedQuantity !== null && row.damagedQuantity !== undefined ? parseFloat(row.damagedQuantity).toFixed(3) : "0.000") : "-",
      row.transactionType === "Transfer" ? (row.lostQuantity !== null && row.lostQuantity !== undefined ? parseFloat(row.lostQuantity).toFixed(3) : "0.000") : "-",
      row.remarks || "-",
      row.issuesBy || "-",
      row.receivedBy || "-"
    ]);

    const totalIssued = allData.reduce((sum, r) => sum + (r.transactionType !== "Inword" ? Number(r.issuedQuantity || 0) : 0), 0);
    const totalQuantity = allData.reduce((sum, r) => sum + (r.transactionType !== "Outword" ? Number(r.quantity || 0) : 0), 0);
    const totalDamaged = allData.reduce((sum, r) => sum + (r.transactionType === "Transfer" ? Number(r.damagedQuantity || 0) : 0), 0);
    const totalLost = allData.reduce((sum, r) => sum + (r.transactionType === "Transfer" ? Number(r.lostQuantity || 0) : 0), 0);

    autoTable(doc, {
      startY: yPosition,
      margin: { top: 48, left: 10, right: 10, bottom: 25 },
      head: headers,
      body,
      foot: [["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Total", totalIssued.toFixed(3), totalQuantity.toFixed(3), totalDamaged.toFixed(3), totalLost.toFixed(3), "", "", ""]],
      showFoot: "lastPage",
      theme: "grid",
      styles: {
        fontSize: 7.5,
        cellPadding: 2,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        overflow: 'linebreak'
      },
      alternateRowStyles: { fillColor: [255, 255, 255] },
      headStyles: { fillColor: [230, 230, 230], textColor: [0, 0, 0], fontStyle: "bold", halign: "center" },
      footStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: "bold" },
      columnStyles: {
        0: { cellWidth: 6, halign: "right" },
        1: { cellWidth: 10, halign: "left" },
        2: { cellWidth: 16, halign: "center" },
        3: { cellWidth: 12, halign: "left" },
        4: { cellWidth: 12, halign: "left" },
        5: { cellWidth: 12, halign: "left" },
        6: { cellWidth: 15, halign: "left" },
        7: { cellWidth: 12, halign: "left" },
        8: { cellWidth: 12, halign: "left" },
        9: { cellWidth: 12, halign: "left" },
        10: { cellWidth: 12, halign: "left" },
        11: { cellWidth: 12, halign: "left" },
        12: { cellWidth: 12, halign: "left" },
        13: { cellWidth: 10, halign: "left" },
        14: { cellWidth: 14, halign: "left" },
        15: { cellWidth: 14, halign: "left" },
        16: { cellWidth: 8, halign: "left" },
        17: { cellWidth: 10, halign: "right" },
        18: { cellWidth: 10, halign: "right" },
        19: { cellWidth: 10, halign: "right" },
        20: { cellWidth: 10, halign: "right" },
        21: { cellWidth: 12, halign: "left" },
        22: { cellWidth: 10, halign: "left" },
        23: { cellWidth: 10, halign: "left" }
      },
      didDrawPage: function (data) {
        if (data.pageNumber === 1) return;
        drawHeader(8);
      }
    });

    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      if (i === pageCount) {
        doc.setFont(undefined, "bold");
        doc.setFontSize(8);
        const footerTop = pageHeight - 20;
        doc.text("Prepared By", 25, footerTop);
        doc.text("Checked By", pageWidth / 2, footerTop, { align: "center" });
        doc.text("Approved By", pageWidth - 25, footerTop, { align: "right" });
      }
      doc.setFont(undefined, "normal");
      doc.setFontSize(8);
      const text = `Page ${i} of ${pageCount}`;
      doc.text(text, pageWidth / 2, pageHeight - 7, { align: "center" });
    }

    doc.save(`InventoryTransactionReport_${utility.formatDateDMY(new Date()).replace(/\//g, "-")}.pdf`);
  };

  const handlePageClick = (event) => {
    const _cp = event.selected + 1;
    setCurrentPage(_cp);
    loadReport(_cp);
  };

  return (
    <>
      <Breadcrumb pageTitle="Inventory Transaction Report" secondTitle="Reports" />
      {message && (
        <div className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"}`}>
          {message}
        </div>
      )}

      <div className="card p-4 bg-white shadow-sm">

        {/* FILTERS */}

        <div className="row g-3 mb-3">

          <div className="col-md-3">
            <label className="form-label">From Company</label>

            {Number(roleId) === 1 ? (
              <select
                className="form-select"
                value={fromCompany}
                onChange={(e) => {
                  const companyId = e.target.value;

                  setFromCompany(companyId);

                  // RESET DEPENDENCIES
                  setFromProject("");
                  setFromStore("");
                  setItemCategory("");
                  setItemName("");

                  setStores([]);
                  setCategories([]);

                  loadProjects(companyId); // reload projects
                }}
              >
                <option value="">Select</option>
                {companies.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.companyName}
                  </option>
                ))}
              </select>
            ) : (
              <input
                className="form-control"
                value={comp.companyName}
                disabled
              />
            )}
          </div>


          <div className="col-md-3">
            <label className="form-label">To Company</label>
            {/* <input
                className="form-control"
                value={toCompany}
                onChange={(e) => setToCompany(e.target.value)}
              /> */}
            <select
              className="form-select"
              value={toCompany}
              onChange={(e) => {
                const companyId = e.target.value;

                setToCompany(companyId);
                setToProject("");
                setToStore("");

                setToStores([]);
                loadToProjects(companyId);
              }}
            >
              <option value="">All</option>
              {companies.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.companyName}
                </option>
              ))}
            </select>

          </div>

          <div className="col-md-3">
            <label className="form-label">From Project</label>
            <select
              className="form-select"
              value={fromProject}
              onChange={(e) => {
                const pid = e.target.value;

                setFromProject(pid);
                setFromStore("");
                setItems([]);

                loadStores(pid, "FROM");
                loadProjectFullData(pid); //  important
              }}
            >
              <option value="">All</option>
              {projects.map((p) => (
                <option key={p.id} value={p.id || p.projectId}>
                  {p.projectName}-{p.projectCode}
                </option>
              ))}
            </select>
          </div>

          {/* FROM STORE */}
          <div className="col-md-3">
            <label className="form-label">From Store</label>
            <select
              className="form-select"
              value={fromStore}
              onChange={(e) => {
                const storeId = e.target.value;

                setFromStore(storeId);

                setItemCategory("");   //  reset
                setItemName("");       //  reset
              }}
              disabled={!fromProject}
            >
              <option value="">All</option>
              {stores.map((s) => (
                <option key={s.storeId || s.id} value={s.storeId || s.id}>
                  {s.storeName}
                </option>
              ))}
            </select>
          </div>

          {/* ITEM CATEGORY */}
          <div className="col-md-3">
            <label className="form-label">Item Category</label>
            <select
              className="form-select"
              value={itemCategory}
              onChange={(e) => {
                setItemCategory(e.target.value);
                setItemName("");
              }}
              disabled={!fromStore}
            >
              <option value="">All</option>
              {categories.map((c) => (
                <option key={c.itemCategoryId} value={c.itemCategoryId}>
                  {c.itemCategoryName}
                </option>
              ))}
            </select>

          </div>


          <div className="col-md-3">
            <label className="form-label">Item</label>
            <select
              className="form-select"
              value={itemName}
              onChange={(e) => setItemName(e.target.value)}
              disabled={!itemCategory}
            >
              <option value="">All</option>
              {projectFullData
                .find(c => String(c.itemCategoryId) === String(itemCategory))
                ?.items?.map(i => (
                  <option key={i.itemId} value={i.itemId}>
                    {i.itemCode}
                  </option>
                ))}
            </select>

          </div>

          <div className="col-md-3">
            <label className="form-label">To Project</label>

            <select
              className="form-select"
              value={toProject}
              onChange={(e) => {
                const pid = e.target.value;

                setToProject(pid);
                setToStore("");

                loadStores(pid, "TO");
              }}
              disabled={!toCompany}
            >
              <option value="">All</option>
              {toProjects.map((p) => (
                <option key={p.id} value={p.id || p.projectId}>
                  {p.projectName}-{p.projectCode}
                </option>
              ))}
            </select>

          </div>

          {/* TO STORE */}
          <div className="col-md-3">
            <label className="form-label">To Store</label>

            <select
              className="form-select"
              value={toStore}
              onChange={(e) => setToStore(e.target.value)}
              disabled={!toProject}
            >
              <option value="">All</option>
              {toStores.map((s) => (
                <option key={s.storeId || s.id} value={s.storeId || s.id}>
                  {s.storeName}
                </option>
              ))}
            </select>

          </div>

          {/* FROM DATE */}
          <div className="col-md-3">
            <label className="form-label">From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          {/* TO DATE */}
          <div className="col-md-3">
            <label className="form-label">To Date</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

        </div>



        {/* VIEW & EXPORT BUTTONS */}

        <div className="text-end mb-3 d-flex justify-content-end align-items-center">



          <div className="d-flex gap-2">
            <button
              className="btn btn-secondary"
              onClick={handleClearFilters}
            >
              <i className="ti ti-refresh me-1"></i>
              Clear
            </button>

            <button
              className="btn btn-primary"
              onClick={handleSearchClick}
            >
              <i className="ti ti-search me-1"></i>
              View Report
            </button>
          </div>

        </div>
        <hr />
        <div className="text-end mb-3 d-flex justify-content-end align-items-center">

          <div className="d-flex gap-2">
            <button
              className="btn btn-success"
              onClick={exportPdf}
              disabled={tableLoading || tableData.length === 0}
            >
              <i className="ti ti-file-type-pdf me-1"></i>
              Export PDF
            </button>

            <button
              className="btn btn-success"
              onClick={exportExcel}
              disabled={tableLoading || tableData.length === 0}
            >
              <i className="ti ti-download me-1"></i>
              Export Excel
            </button>
          </div>


        </div>
        {/* TABLE */}
        <div className="table-responsive">

          <table className="table table-bordered table-striped">
            <thead className="table-light">
              <tr>
                <th>Transaction Type</th>
                <th>Transaction Date</th>
                <th>From Company</th>
                <th>From Project Code</th>
                <th>From Project</th>
                <th>To Location</th>
                <th>From Store</th>
                <th>To Company</th>
                <th>To Project Code</th>
                <th>To Project</th>
                <th>To Store</th>
                <th>Invoice No</th>
                <th>Vehicle No</th>
                <th>Category</th>
                <th>Item Name</th>
                <th>UOM</th>
                <th>Issue Qty</th>
                <th>Quantity</th>
                <th>Damaged Qty</th>
                <th>Lost Qty</th>
                <th>Remarks</th>
                <th>Issues By</th>
                <th>Received By</th>
              </tr>
            </thead>

            <tbody>
              {tableLoading ? (
                <tr>
                  <td colSpan="23" className="text-center">
                    <div className="spinner-border text-primary" />
                  </td>
                </tr>
              ) : tableData.length === 0 ? (
                <tr>
                  <td colSpan="23" className="text-center">
                    No data found
                  </td>
                </tr>
              ) : (
                tableData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.transactionType}</td>
                    <td>{utility.formatDateTime(row.transactionDate)}</td>
                    <td>{row.fromCompany || "-"}</td>
                    <td>{row.fromProjectCode || "-"}</td>
                    <td>{row.fromProject ? (() => {
                      const cat = row.fromProjectCategory || row.fromCategory || (projects.find(p => String(p.id || p.projectId) === String(row.fromProjectId || fromProject) || (row.fromProject && String(p.projectName).trim().toLowerCase() === String(row.fromProject).trim().toLowerCase()))?.categoryName) || (toProjects.find(p => String(p.id || p.projectId) === String(row.fromProjectId || fromProject) || (row.fromProject && String(p.projectName).trim().toLowerCase() === String(row.fromProject).trim().toLowerCase()))?.categoryName) || "";
                      let init = String(cat).trim().charAt(0).toUpperCase();
                      if (!init && row.fromProjectCode) {
                        init = String(row.fromProjectCode).trim().charAt(0).toUpperCase();
                      }
                      return init ? `${init}*${row.fromProject}` : row.fromProject;
                    })() : "-"}</td>
                    <td>{row.toLocation || "-"}</td>
                    <td>{row.fromStore || "-"}</td>
                    <td>{row.toCompany || "-"}</td>
                    <td>{row.toProjectCode || "-"}</td>
                    <td>{row.toProject ? (() => {
                      const cat = row.toProjectCategory || row.toCategory || (toProjects.find(p => String(p.id || p.projectId) === String(row.toProjectId || toProject) || (row.toProject && String(p.projectName).trim().toLowerCase() === String(row.toProject).trim().toLowerCase()))?.categoryName) || (projects.find(p => String(p.id || p.projectId) === String(row.toProjectId || toProject) || (row.toProject && String(p.projectName).trim().toLowerCase() === String(row.toProject).trim().toLowerCase()))?.categoryName) || "";
                      let init = String(cat).trim().charAt(0).toUpperCase();
                      if (!init && row.toProjectCode) {
                        init = String(row.toProjectCode).trim().charAt(0).toUpperCase();
                      }
                      return init ? `${init}*${row.toProject}` : row.toProject;
                    })() : "-"}</td>
                    <td>{row.toStore}</td>
                    <td>{row.invoiceNo}</td>
                    <td>{row.vehicleNo}</td>
                    <td>{row.category}</td>
                    <td>{row.itemCode}</td>
                    <td>{row.uomCode}</td>
                    <td>{row.transactionType !== "Inword" ? Number(row.issuedQuantity || 0).toFixed(3) : "-"}</td>
                    <td>{row.transactionType !== "Outword" ? Number(row.quantity || 0).toFixed(3) : "-"}</td>
                    <td>{row.transactionType === "Transfer" ? (row.damagedQuantity !== null && row.damagedQuantity !== undefined ? parseFloat(row.damagedQuantity).toFixed(3) : "0.000") : "-"}</td>
                    <td>{row.transactionType === "Transfer" ? (row.lostQuantity !== null && row.lostQuantity !== undefined ? parseFloat(row.lostQuantity).toFixed(3) : "0.000") : "-"}</td>
                    <td>{row.remarks}</td>
                    <td>{row.issuesBy}</td>
                    <td>{row.receivedBy}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <ReactPaginate
            breakLabel="..."
            nextLabel="Next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            previousLabel="< Previous"
            containerClassName="pagination-container"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            activeClassName="active"
          />
        </div>
      </div>
    </>
  );
}
